


























































import { Vue, Component, Prop } from 'vue-property-decorator';

import { anyWordMatches } from '~/utils/word';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import XSolid from '~/components/icons/XSolid.vue';
import Dropdown from '~/components/partials/Dropdown.vue';

@Component({
  components: { ChevronRightSolid, XSolid, Dropdown },
})
export default class RoutesCitiesDropdown extends Vue {
  @Prop(Array) elements: [];
  @Prop(String) selectedCity: '';

  $refs: {
    dropdown: HTMLButtonElement;
    chevron: Vue,
  };

  searchText: string = '';

  /*
    This computed returns filtered cities that look like this.searchText,
    or returns all of them if this.searchText isn't defined
  */
  get filteredCities () {
    if (this.searchText) {
      /* eslint-disable-next-line */
      const filtered = this.elements.filter((city: string) => {
        return anyWordMatches(this.searchText, [city]);
      });

      return filtered;
    }
    return this.elements;
  }

  /* Utils method to handle dropdown behavior if user clicks out of it */
  handleClick (val: boolean) {
    if (!val) this.bluredBtn();
    else this.focusedBtn();
  }

  /* Applies focused styles */
  focusedBtn () {
    this.$refs.dropdown.classList.remove('border-gray-200');
    this.$refs.dropdown.classList.add('border-gray-default');
    this.$refs.chevron.$el.classList.add('-rotate-180', '-rotate-90');
  }

  /* Closes active dropdown and removes focused styles */
  bluredBtn () {
    if (!this.selectedCity) this.$refs.dropdown.classList.remove('border-gray-default');
    this.$refs.chevron.$el.classList.remove('-rotate-180', '-rotate-90');
  }
}
